export default __webpack_public_path__ + "static/techbureau-ed98fdccbece6403125f86c2a8197604.png";